module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Da-Ea.cac0fb1e.png";